import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-turns-reports-cancelled-card',
  templateUrl: './turns-reports-cancelled-card.component.html',
  styleUrls: ['./turns-reports-cancelled-card.component.scss']
})
export class TurnsReportsCancelledCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
